import * as React from 'react';

import { cn } from '@blockworks/ui/utils';

type BlockHeaderProps = {
    className?: string;
    title: string;
    subTitle?: string;
};

const BlockHeader = (props: BlockHeaderProps) => {
    const { title, subTitle, className } = props;

    return (
        <div className={cn('flex flex-col justify-center items-center relative gap-3', className)}>
            {subTitle && <p className="text-sm text-center uppercase text-[#5637cd]">{subTitle}</p>}
            <p className="text-2xl md:text-3xl lg:text-4xl max-w-4xl font-semibold text-center text-[#110b29]">
                {title}
            </p>
        </div>
    );
};

export default BlockHeader;
